import React from "react";
import { Select } from "antd";
import "./dropdownSelect.scss"; // Import custom styles

const DropdownSelect = ({ label, options, placeholder, mode, ...props }) => {
  return (
    <div className="custom-dropdown-container">
      {label && <label className="custom-label">{label}</label>}
      <Select
        placeholder={placeholder}
        {...props}
        className="custom-select"
        mode={mode}
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default DropdownSelect;
